import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import React from 'react'
import PeopleLikeMeSelectionPanels from './PeopleLikeMeSelectionPanels'

interface Props {
  onCustomerTypeClick: () => void
}

function PeopleLikeMeHeaderEntry(props: Props) {
  const { onCustomerTypeClick } = props
  return (
    <VerticalSpacer gap={8}>
      <BodyText variant="large" weight="bold">Which traveller type are you?</BodyText>
      <BodyText variant="medium">Get inspired on where to go next by our 7 million Luxury Escape travellers!</BodyText>
      <PeopleLikeMeSelectionPanels onClick={onCustomerTypeClick} />
    </VerticalSpacer>
  )
}

export default PeopleLikeMeHeaderEntry
